<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-grid">
        <div class="col col-brand">
          <div class="f-brand">
            <span class="f-mark">
              <svg viewBox="0 0 28 28" fill="none" aria-hidden="true">
                <path
                  d="M14 2l10 5.5v11L14 24l-10-5.5v-11L14 2z"
                  stroke="currentColor"
                  stroke-width="2"
                />
                <circle cx="14" cy="14" r="3.4" fill="currentColor" />
              </svg>
            </span>
            <div>
              <b>{{ site.companyName }}</b>
              <i>{{ site.companyNameEn }}</i>
            </div>
          </div>
          <p class="f-desc">{{ site.description }}</p>
        </div>

        <div class="col">
          <h4>快速导航</h4>
          <ul>
            <li v-for="item in site.nav" :key="item.path">
              <router-link :to="item.path">{{ item.name }}</router-link>
            </li>
          </ul>
        </div>

        <div class="col">
          <h4>业务服务</h4>
          <ul>
            <li v-for="s in services" :key="s.id">
              <router-link :to="`/services#${s.id}`">{{ s.name }}</router-link>
            </li>
          </ul>
        </div>

        <div class="col">
          <h4>联系我们</h4>
          <ul class="contact-list">
            <li>
              <span>电话</span>
              <a :href="`tel:${site.phone.replace(/-/g, '')}`">{{ site.phone }}</a>
            </li>
            <li>
              <span>邮箱</span>
              <a :href="`mailto:${site.email}`">{{ site.email }}</a>
            </li>
            <li>
              <span>地址</span>
              <p>{{ site.address }}</p>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <p>© {{ year }} {{ site.companyName }} · {{ site.companyNameEn }} 版权所有</p>
        <p>{{ site.icp }}</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import site from '@/data/site'
import services from '@/data/services'

const year = new Date().getFullYear()
</script>

<style scoped>
.site-footer {
  background: var(--hl-dark);
  color: rgba(255, 255, 255, 0.75);
  padding: 72px 0 0;
  position: relative;
  overflow: hidden;
}

.site-footer::before {
  content: '';
  position: absolute;
  top: -160px;
  right: -120px;
  width: 420px;
  height: 420px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(11, 92, 255, 0.28), transparent 65%);
  pointer-events: none;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1.2fr;
  gap: 48px;
  padding-bottom: 56px;
}

.f-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.f-mark {
  width: 44px;
  height: 44px;
  border-radius: 11px;
  display: grid;
  place-items: center;
  color: #fff;
  background: linear-gradient(135deg, var(--hl-blue), var(--hl-cyan));
}

.f-mark svg {
  width: 25px;
  height: 25px;
}

.f-brand b {
  display: block;
  color: #fff;
  font-size: 20px;
  letter-spacing: 1px;
}

.f-brand i {
  font-style: normal;
  font-family: var(--font-display);
  font-size: 11px;
  letter-spacing: 3px;
  color: var(--hl-cyan);
}

.f-desc {
  margin-top: 18px;
  font-size: 14px;
  line-height: 1.9;
  max-width: 320px;
  color: rgba(255, 255, 255, 0.6);
}

.col h4 {
  color: #fff;
  font-size: 16px;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
}

.col h4::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 26px;
  height: 2px;
  background: var(--hl-cyan);
  border-radius: 2px;
}

.col ul li {
  margin-bottom: 12px;
}

.col ul li a {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.65);
  transition: color 0.3s, padding-left 0.3s;
}

.col ul li a:hover {
  color: var(--hl-cyan);
  padding-left: 4px;
}

.contact-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.65);
}

.contact-list li span {
  color: var(--hl-cyan);
  flex-shrink: 0;
  font-weight: 600;
}

.contact-list li p {
  line-height: 1.7;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 22px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.45);
}

@media (max-width: 992px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
}

@media (max-width: 640px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  .footer-bottom {
    flex-direction: column;
    text-align: center;
  }
}
</style>
